import { hueFromString, initialsOf } from '@moussenaires/shared';

import './Avatar.css';

interface AvatarProps {
  name: string;
  avatarUrl?: string | null;
  size?: number;
}

export function Avatar({ name, avatarUrl, size = 34 }: AvatarProps) {
  if (avatarUrl) {
    return (
      <img
        className="avatar avatar-img"
        src={avatarUrl}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
      />
    );
  }

  const hue = hueFromString(name);
  return (
    <div
      className="avatar avatar-fallback"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: `hsl(${hue} 70% 42%)`,
      }}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </div>
  );
}
